import { GameState } from '../shared/types.js';
import { $, hide } from './utils.js';

let lastCardId: number | null = null;
let lastMovementNoticeId: number | null = null;
let autoDismissTimer: number | null = null;
let movementDismissTimer: number | null = null;

function dismissCardModal(): void {
  if (autoDismissTimer !== null) {
    clearTimeout(autoDismissTimer);
    autoDismissTimer = null;
  }
  hide($('#card-modal'));
}

export function initCardModal(): void {
  const dismissBtn = $('#card-dismiss');
  dismissBtn.addEventListener('click', dismissCardModal);
}

function getMovementToast(): HTMLElement {
  let toast = document.getElementById('movement-toast');
  if (!toast) {
    toast = document.createElement('div');
    toast.id = 'movement-toast';
    toast.className = 'movement-toast hidden';
    toast.setAttribute('role', 'status');
    toast.setAttribute('aria-live', 'polite');
    document.body.appendChild(toast);
  }
  return toast;
}

function showMovementToast(text: string): void {
  const toast = getMovementToast();
  toast.textContent = text;
  toast.classList.remove('hidden');

  if (movementDismissTimer !== null) {
    clearTimeout(movementDismissTimer);
  }
  movementDismissTimer = window.setTimeout(() => {
    toast.classList.add('hidden');
    movementDismissTimer = null;
  }, 2000);
}

export function checkCardDrawn(state: GameState): void {
  // Card modal popup disabled — card text is shown in the status message instead.
  if (state.lastCard && state.lastCard.id !== lastCardId) {
    lastCardId = state.lastCard.id;
  }

  if (state.movementNotice && state.movementNotice.id !== lastMovementNoticeId) {
    lastMovementNoticeId = state.movementNotice.id;
    showMovementToast(state.movementNotice.text);
  }
}
